import { Component, TemplateRef, ViewChild } from '@angular/core'

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  @ViewChild('tooltip') tooltip: TemplateRef<{ $implicit: string }>
}
